export const PUBLISH_PANEL_ID = "publish";

export const PUBLISH_TREE_TITLE_OFFSET = 30;
